import { FC, useState } from 'react';
import { useGetCurrentLocation } from 'view/pages/profile/hooks/useGetCurrentLocation';
import Autocomplete from 'view/components/Autocomplete';

const LocationAutocomplete: FC<any> = ({
  setValue,
  currentLocationValue,
  label = 'Current Location',
}) => {
  const [inputValue, setInputValue] = useState('');
  const [page, setPage] = useState(1);

  const { data, isLoading } = useGetCurrentLocation(10, page, inputValue);

  return (
    <Autocomplete
      name="currentLocation"
      label={label}
      value={currentLocationValue}
      onChange={(value: any) => {
        return setValue('currentLocation', value);
      }}
      inputValue={inputValue}
      setInputValue={setInputValue}
      page={page}
      setPage={setPage}
      data={data}
      isLoading={isLoading}
      getOptionLabel={(option: any) => {
        return `${option.name}`; /* , ${option.state.code} */
      }}
    />
  );
};

export default LocationAutocomplete;
